import { Fab } from "@mui/material";

const AtomicCircleButton = ({ disabled, onClick, style }) => {
    return <Fab
        disabled={disabled}
        size="small"
        color="primary"
        aria-label="add"
        onClick={onClick}
        sx={{ zIndex: '3', fontSize: '16px', backgroundColor: '#181436', marginBottom: '10px', ':hover': { backgroundColor: '#FF7A28' }, ...style }}
    >
        +
    </Fab>;
}

export default AtomicCircleButton;